const DEV = process.env.NODE_ENV !== 'production'
const HOST_NAME = DEV ? '//cstest.didiglobal.com' : `//${window.location.host}`;
const QIANKUN_CONFIG = [
	{
		name: 'kfcommon-fe-i18n',
		id: [11112,11113], // 工单系统 工单配置 消息系统 知识库
		// entry: `${HOST_NAME}/static/kfcommon/index.html?_t=${new Date().getTime()}${DEV ? '&&test=2': ''}`,
		entry: `${HOST_NAME}/static/kfcommon/index.html?_t=${new Date().getTime()}${DEV ? '&&test=2': ''}`,
		activeRule: `/ark_fe`,
	}
]
export default QIANKUN_CONFIG